/** One suggestion returned by GET /addresses/autocomplete. */
export interface AddressAutocompleteItem {
  id: string;
  text: string;
  highlight: string;
  cursor: number;
  description: string;
  next: string;
}

/** Selection payload emitted when the customer picks an autocomplete suggestion. */
export interface AddressAutocompleteSelection {
  id: string;
  text: string;
  description: string;
  next: string;
}

/** Query parameters for GET /addresses/autocomplete. */
export interface AddressAutocompleteRequest {
  searchTerm: string;
  country: string;
  languagePreference?: string;
  maxItems?: number;
  lastId?: string;
}

/** Minimum trimmed characters before autocomplete requests are sent. */
export const ADDRESS_AUTOCOMPLETE_MIN_SEARCH_LENGTH = 2;

/** Debounce delay between street address keystrokes and autocomplete requests. */
export const ADDRESS_AUTOCOMPLETE_DEBOUNCE_MS = 300;

/** Default country for Canadian shipment address forms. */
export const ADDRESS_AUTOCOMPLETE_DEFAULT_COUNTRY = 'CA';

/** Default maxItems when the query parameter is omitted (backend default). */
export const ADDRESS_AUTOCOMPLETE_DEFAULT_MAX_ITEMS = 100;
